import { makeFetchListActionCreator } from 'store/common/actions/makeFetchListActionCreator'
import { makeFetchItemActionCreator } from 'store/common/actions/makeFetchItemActionCreator'
import { makeFetchStaticActionCreator } from 'store/common/actions/makeFetchStaticActionCreator'
import { makeCreateItemActionCreator } from 'store/common/actions/makeCreateItemActionCreator'
import { makeUpdateItemActionCreator } from 'store/common/actions/makeUpdateItemActionCreator'
import { makeUpdateStoreItemActionCreator } from 'store/common/actions/makeUpdateStoreItemActionCreator'
import { makeDeleteItemActionCreator } from 'store/common/actions/makeDeleteItemActionCreator'
import { makeResetListActionCreator } from 'store/common/actions/makeResetListActionCreator'

import { storeEntityCreator } from 'store/common/entities/storeEntityCreator'
import { storeEntityListCreator } from 'store/common/entities/storeEntityListCreator'
import { storeEntityStaticsCreator } from 'store/common/entities/storeEntityStaticsCreator'

import {
  makeGetState,
  makeGetOptions,
  makeGetStatics,
  makeGetStaticsEntity,
  makeGetEntitiesCollection,
  makeGetEntitiesArray,
  makeGetEntityListPages,
  makeGetEntityListMeta,
  makeGetEntityListIds,
  makeGetEntityById,
  makeGetEntityByFilter,
  makeGetEntitiesArrayFromList,
  makeGetEntitiesCollectionFromList,
  makeGetEntitiesArrayFromListByPage,
  makeGetEntitiesArrayFromListBeforePage,
} from 'store/common/selectors/higherOrderSelectorCreators'

import { ACTION_TYPES } from 'store/common/constants/actionsTypes'
import * as storeConstants from 'store/common/constants/generic'

export const actionsCreators = {
  makeFetchList: makeFetchListActionCreator,
  makeFetchItem: makeFetchItemActionCreator,
  makeFetchStaticItem: makeFetchStaticActionCreator,
  makeCreateItem: makeCreateItemActionCreator,
  makeUpdateItem: makeUpdateItemActionCreator,
  makeUpdateStoreItem: makeUpdateStoreItemActionCreator,
  makeDeleteItem: makeDeleteItemActionCreator,
  makeResetItem: makeResetListActionCreator,
}

export const entitiesCreators = {
  createStoreEntity: storeEntityCreator,
  createStoreEntityList: storeEntityListCreator,
  createStoreEntityStatic: storeEntityStaticsCreator,
}

export const selectorsCreators = {
  makeGetState,
  makeGetOptions,
  makeGetStatics,
  makeGetStaticsEntity,
  makeGetEntitiesCollection,
  makeGetEntitiesArray,
  makeGetEntityListPages,
  makeGetEntityListMeta,
  makeGetEntityListIds,
  makeGetEntityById,
  makeGetEntityByFilter,
  makeGetEntitiesArrayFromList,
  makeGetEntitiesCollectionFromList,
  makeGetEntitiesArrayFromListByPage,
  makeGetEntitiesArrayFromListBeforePage,
}

export const actionsTypes = {
  ...ACTION_TYPES,
}

export const constants = {
  ...storeConstants,
}
